import React from 'react'
import { trans } from '../../../../_providers/Translation'
import Help from '../../../partials/Help'

const Filter = (props) => {

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleClearFilters = () => {
        props.handleSearch('name', '')
        props.handleSearch('type_value', '')
    }

    return (
        <>
            <form className="filter-standard">
                <div className='col'>
                    <input
                        type='search'
                        name='name'
                        onChange={handleSearch}
                        onKeyUp={handleSearch}
                        value={props.filter.name}
                        placeholder={trans('labels.name')}
                    />
                </div>
                <div className='col'>
                    <select
                        onChange={handleSearch}
                        name='type_value'
                        value={props.filter.type_value}
                    >
                        <option value=''>{trans('random.allTypes')}</option>
                        {props.types.map(i => (
                            <option key={'type-' + i.value} value={i.value}>{i?.label}</option>
                        ))}
                    </select>
                </div>
                <div className='col'>
                    <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                        {trans('buttons.clearFilter')}
                    </button>
                </div>
            </form>
        </>
    )
}
export default Filter